import Routes from "../router/Routes";
export default function useHeaderColor() {

    const onRouteIdIsPresent = (route, hook) => {
        if (typeof route === 'undefined') return;
        hook(document.getElementById('appHeader'));
    }


    onRouteIdIsPresent(Routes.getRouteByColor('coral'), (headerElement) => {
        headerElement.setAttribute('data-color', 'coral');
    })

    onRouteIdIsPresent(Routes.getRouteByColor('green'), (headerElement) => {
        headerElement.setAttribute('data-color', 'green');
    })

    onRouteIdIsPresent(Routes.getRouteByColor('gray'), (headerElement) => {
        headerElement.setAttribute('data-color', 'gray');
    })

    onRouteIdIsPresent(Routes.getRouteByColor('default'), (headerElement) => {
        headerElement.setAttribute('data-color', 'default');
    })
}
